export const isDeployError = (error: Error): boolean => {
  const message = error.message || '';

  return (
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Importing a module script failed') ||
    message.includes('error loading dynamically imported module')
  );
};

export const errorReload = (retries = 2): void => {
  const url = new URL(window.location.href);
  const errRetries = Number(url.searchParams.get('errRetries') || '0');

  if (errRetries >= retries) {
    window.history.replaceState(null, '', url.pathname);
    return;
  }

  url.searchParams.set('errRetries', String(errRetries + 1));

  window.location.href = url.toString();
};
